module.exports = __webpack_public_path__ + "img/ring_skip_0_null_0@2x.c4d636c4.png";